module.exports = __webpack_public_path__ + "static/media/search.91fe00fb.png";